export default {
  menu: {
    sports: "スポーツ",
    referAndEarn: "紹介して稼ぐ",
    referDesc: "最大60%のコミッション",
    copyLink: "リンクをコピー",
    hot: "人気",
    favorites: "お気に入り",
    recent: "最近",
    vipClub: "VIPクラブ",
    bonus: "ボーナス",
    bonusGames: "ボーナスゲーム",
    affiliate: "アフィリエイト",
    promotion: "プロモーション",
    rewards: "報酬",
    help: "ヘルプ",
    feedback: "フィードバック",
    downloadApp: "アプリをダウンロード",
    claimBonus: "ボーナスを受け取る",
    redeemCode: 'コード引き換え',
    redeemDesc: '無料リワードを受け取る',
    liveSupport: "ライブサポート",
    language: "言語",
	search: "search"
  }
}
